export const MUTATION_ENTITY_SET = "mutationEntitySet";

export const ACTION_ENTITY_FETCH = "actionEntityFetch";
export const ACTION_ENTITY_CREATE = "actionEntityCreate";
export const ACTION_ENTITY_EDIT = "actionEntityEdit";
export const ACTION_ENTITY_DELETE = "actionEntityDelete";
